import { render, staticRenderFns } from "./walletSecret2FA.popup-chunk.vue?vue&type=template&id=1aa0789e&scoped=true"
import script from "./walletSecret2FA.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./walletSecret2FA.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./walletSecret2FA.popup-chunk.vue?vue&type=style&index=0&id=1aa0789e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0789e",
  null
  
)

export default component.exports